export default __webpack_public_path__ + "static/media/sixtyPercentageThreshold.08618aea.svg";